export default __webpack_public_path__ + "static/media/golf6-box.1982e958.png";